export const SET_MENUS = "SET_MENUS";
